export const contract = {
  Contract: 'Contrato',
  'Contracted areas': 'Áreas contratadas',
  Details: 'Detalhes',
  Payments: 'Pagamentos',
};
